// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"babe65e7","1048":"a3ed25f7","3018":"de08baa4","6119":"a3ed25f7","7401":"a3ed25f7","8163":"50547556"}[chunkId] + ".chunk.css";
};